export const MATCH_EVENTS = {
  ACTION_TYPES: {
    onPlayerCardPopupClick: 'onPlayerCardPopupClick'
  },

  EVENT_TYPES: {
    goal: 1,
    yellowCard: 2,
    redCard: 3,
    substitution: 1000,
    penaltyMiss: 6,
  },

  PLACEHOLDERS: {
    minimumStages: 2,
    minimumRows: 4,
    stageHeight: 20,
    rowHeight: 40,
    tabsHeight: 82,
  }
};